import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom'
import './PasswordInfo.scss'
import '../personal-info/PersonalInfo.scss'
import '../../input-elements/password/Password.scss'
import PasswordInput from '../../input-elements/password/PasswordInput';
import PasswordCreatorInput from '../../input-elements/password/PasswordCreatorInput';
import AltButton from '../../button/AltButton';
import ActionButton from '../../button/ActionButton';
import HrbTranslate from '../../language/HrbTranslate';
import Api from '../../../services/api/Api';
import { ApiPaths } from '../../../services/api/ApiPaths';

class PasswordInfoEdit extends Component {
    constructor(props) {
        super(props);
        // let's assume our initial state is ok
        this.state = {
            action: null,
            current_pw: {
                value: '',
                validated: false,
                errorKey: null,
                errorParams: null
            },
            new_password: {
                value: '',                
                isValid: false
            }
        };
    }

    componentDidMount() {
        var el = document.getElementById('password-info-edit-form');
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }

    onBlur = (key) => {
        if (key === 'current_pw') {
            this.setState({
                current_pw: {
                    ...this.state.current_pw,
                    validated: true,
                    errorKey: !this.state.current_pw.value ? 'profile.personal_info_edit.errors.missing_field' : null
                }
            })
        } else if (key === 'new_password') {
            this.setState({
                new_password: {
                    requirementsMet: this.state.new_password.requirementsMet,
                    value: this.state.new_password.value
                }
            })
        }
    }

    onPasswordChange = (propertyName, value, requirementsMet) => {
        this.setState({
            new_password: {
                value: value,
                requirementsMet
            }
        });
    }

    onChange = (key, value) => {
        this.setState({
            current_pw: {
                ...this.state.current_pw,
                value: value,
                errorKey: this.state.current_pw.validated && !value ? 'profile.personal_info_edit.errors.missing_field' : null
            }
        })
    }

    onCancel = () => {
        this.props.history.goBack();
    }

    createPasswordRequest = () => {
        if (this.state.current_pw.value && this.state.new_password.requirementsMet) {
            return {
                userName: this.props.profile.userName,
                lang: this.props.lang,
                currentPassword:this.state.current_pw.value,
                password: this.state.new_password.value
            }
        } else {
            return null
        }

    }

    saveChanges = () => {
        var payload = this.createPasswordRequest();
        if (!payload) {
            return;
        }

        this.setState({ action: 'saving' });
        Api.put(ApiPaths.UPDATE_PASSWORD.replace("__AID__", this.props.profile.id), payload).then(
            (response) => {
                if (response.status !== 200) {
                    // TODO: Show an error message of the appropriate type
                    this.setState({ action: null })
                } else {
                    if (response.data.status !== "SUCCESS") {
                        if (response.data.incorrectPassword) {
                            this.setState({
                                current_pw: {
                                    ...this.state.current_pw,
                                    validated: true,
                                    errorKey: 'profile.password_info.errors.pw_no_match',
                                    errorParams: (
                                        <a className="hrb-inline-link" href="/forgot-password?clientId=portaloidc">
                                            <HrbTranslate text="profile.password_info.errors.pw_no_match_link" />
                                        </a>
                                    )
                                },
                                action: null
                            })
                            return;
                        } else {
                            // TODO: something went wrong
                            this.setState({ action: null })
                            return;
                        }
                    }
                    this.setState({ action: 'complete' });
                    setTimeout(() => {
                        this.props.profileUpdated();
                    }, 1200);
                }
            },
            (error) => {
                // TODO: Need to show another error to the user
                this.setState({
                    action: null,
                    errorCode: 500
                });
            }
        );

    }

    render() {
        var canSave = this.state.current_pw.value && this.state.new_password.requirementsMet;
        return (
            <div className="hrb-profile-personal-container-edit" id='password-info-edit-form'>
                <form id="update-password-form">
                    <div className="hrb-profile-personal-container-edit">
                        <div className="hrb-profile-message-row">
                            <HrbTranslate text="profile.personal_info_edit.required_warn" />
                        </div>
                        <div className="hrb-profile-pw-edit-row">
                            <div className="hrb-profile-pw-edit-item hrb-pw-left-side">
                                <PasswordInput
                                    propertyName='current_pw'
                                    isPassword={true}
                                    labelKey='profile.password_info.current_password'
                                    value={this.state.current_pw.value}
                                    onBlur={this.onBlur}
                                    onChange={this.onChange}
                                    lang={this.props.lang}
                                    errorKey={this.state.current_pw.errorKey}
                                    extraErrorContent={this.state.current_pw.errorParams}
                                />
                            </div>
                            <div className="hrb-profile-pw-edit-item hrb-pw-right-side">
                                <div className="hrb-profile-pw-filler" />
                            </div>
                        </div>
                        <div className="hrb-profile-pw-spacer-row" />
                        <div className="hrb-profile-pw-edit-row">
                            <PasswordCreatorInput value={this.state.new_password.value} onChange={this.onPasswordChange}
                                onBlur={this.onBlur} propertyName="new_password"
                            />
                        </div>
                                        
                        <div className="hrb-profile-edit-buttons">
                            <AltButton text='common.cancel' onClick={this.onCancel} />
                            <ActionButton text='common.save_changes' onClick={this.saveChanges} isDisabled={!canSave}
                                inProgress={this.state.action === 'saving'} complete={this.state.action === 'complete'}
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
};

PasswordInfoEdit.propTypes = {
    profile: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    profileUpdated: PropTypes.func.isRequired
};

export default withRouter(PasswordInfoEdit);
